import React from "react";
import { useAuth, useAutoSignin } from "react-oidc-context";

import { CssBaseline } from "@mui/material";
import { Outlet } from "react-router";
import { useEffect } from "react";
import oidcAuth from "../oidc-config";

import Header from "../components/Header";
import { Box, Button } from "@mui/material";
import background from "../assets/images/bg2.png";

function RootLayout() {

  const { isLoading, isAuthenticated } = useAutoSignin();
  const auth = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [isAuthenticated]);

  let oidcConfig = {};
  // Read environment stage safely (support Vite import.meta.env and process.env)
  let env = {};
  try {
    env = import.meta?.env || {};
  } catch (e) {
    env = (typeof process !== 'undefined' && process.env) ? process.env : {};
  }
  const environment = env.VITE_APP_STAGE || env.REACT_APP_STAGE || "dev";
  if (environment === "dev") {
    oidcConfig = oidcAuth.dev;
  } else if (environment === "stg") {
    oidcConfig = oidcAuth.staging;
  } else if (environment === "ppd") {
    oidcConfig = oidcAuth.preprod;
  } else if (environment === "prd") {
    oidcConfig = oidcAuth.prod;
  } else {
    oidcConfig = oidcAuth.dev;
  }

  let updatedOidcConfig = {};

  if (environment === "dev") {
    if (typeof window !== "undefined") {
      const isLocalhost = Boolean(
        window.location.hostname === "localhost" ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === "[::1]" ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
      );

      // Assuming you have two redirect URIs, and the first is for localhost and second is for production
      const [localRedirectSignIn, productionRedirectSignIn] =
        oidcConfig.redirectSignIn.split(",");

      const [localRedirectSignOut, productionRedirectSignOut] =
        oidcConfig.redirectSignOut.split(",");

      updatedOidcConfig = {
        ...oidcConfig,
        oauth: {
          ...oidcConfig.oauth,
          redirectSignIn: isLocalhost ? localRedirectSignIn : productionRedirectSignIn,
          redirectSignOut: isLocalhost ? localRedirectSignOut : productionRedirectSignOut,
        },
      };

      // Amplify.configure(updatedOidcConfig);
      // Auth.configure();
    }
  } else {
    updatedOidcConfig = { ...oidcConfig };
    // Amplify.configure(oidcConfig);
    // Auth.configure();
  }

  function AuthComponent() {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          minWidth: '100vw',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          component="img"
          src={background}
          alt="Coca Coal MixCodes"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            objectFit: 'cover',
            zIndex: 0,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
            color: 'white',
            background: 'rgba(0,0,0,0.3)',
          }}
        >
          <Box sx={{ textAlign: 'center', fontSize: 32, mb: 4, fontWeight: 600, textShadow: '0 2px 8px #000' }}>
            Welcome to Mix Codes
          </Box>
          <Button
            variant="contained"
            size="large"
            onClick={() => {
              auth.signinRedirect();
            }}
            sx={{ mt: 2, fontSize: 20, px: 6, py: 2 }}
          >
            Sign in using SSO
          </Button>
        </Box>
      </Box>
    );
  }

  if (isLoading) {
    return <CssBaseline />;
  }

  if (!isAuthenticated) {
    return (
      <>
        <CssBaseline />
        <AuthComponent />
      </>
    );
  }

  return (
    <>
      <CssBaseline />
      <Header />
      <Outlet />
    </>
  );
}

export default RootLayout;
